<template>
  <div class="repeater-collapse">
    <Collapse :opened="open" :wide="wide" ref="collapse">
      <!-- Collapse header -->
      <template slot="header">
        <slot name="header" />
      </template>

      <template>
        <div class="repeater-collapse__cotainer">
          <div class="row m-0">
            <div class="col-1/x">
              <!-- Collapse Body -->
              <div class="repeater-collapse__body">
                <!-- Body -->
                <slot />
              </div>
            </div>

            <div class="col-auto">
              <div class="repeater-collapse__actions">
                <!-- Actions -->
                <slot name="actions" />
              </div>
            </div>
          </div>
        </div>
      </template>
    </Collapse>
  </div>
</template>

<script>
/** Components */
import Collapse from '@/components/Collapse.vue'

export default {
  components: {
    Collapse,
  },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
